import React from 'react'
import PropTypes from 'prop-types'

const splitFeatureString = (featureString) => {
  if (featureString && featureString.length){
    return featureString.split('\n').filter(string => string)
  }

  return []
}

class KeyFeaturesWrapper extends React.Component {
  render(){
    const { campaign: { other_features }, render } = this.props
    const featureArray = splitFeatureString(other_features)

    if (!featureArray.length) return null

    return render({
      features: featureArray,
    })
  }
}

KeyFeaturesWrapper.propTypes = {
  campaign: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

export default KeyFeaturesWrapper
